module.exports = __webpack_public_path__ + "static/media/back-arrow.04c45cf2.svg";